"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = __importStar(require("js-cookie"));
var React = __importStar(require("react"));
var arrowDown_icon_1 = require("../../../svg/status/arrowDown.icon");
var core_components_1 = require("@securityproducts/core-components");
var reportNavigation_styles_1 = require("../../common/report-navigation/reportNavigation.styles");
var datePickerCard_1 = require("../date-picker/datePickerCard");
var historicalNavigation_styles_1 = require("./historicalNavigation.styles");
var historicalNavigation_i18n_1 = require("./historicalNavigation.i18n");
function HistoricalNav(props) {
    var _a = React.useState(props.display || "DAYS"), display = _a[0], setDisplay = _a[1];
    var _b = React.useState(props.showDatePicker || false), showDatePicker = _b[0], setShowDatePicker = _b[1];
    var _c = React.useState(false), archiveMode = _c[0], setArchiveMode = _c[1];
    var strings = core_components_1.useLocalisation(historicalNavigation_i18n_1.historicalReportNavigationTranslations, props.language);
    function getReport() {
        return __awaiter(this, void 0, void 0, function () {
            var guid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props.setLoading(true);
                        guid = Cookies.get("guid");
                        return [4 /*yield*/, Promise.all([
                                props.getReport({
                                    guid: guid,
                                    agent: props.agent,
                                    fromDate: props.fromDate,
                                    toDate: props.toDate,
                                    display: display,
                                    archiveMode: archiveMode,
                                }),
                                new Promise(function (resolve) {
                                    // Minimum spin time
                                    setTimeout(function () {
                                        resolve("resolved");
                                    }, 1000);
                                }),
                            ]).then(function () {
                                props.setLoading(false);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "date-range", className: showDatePicker ? reportNavigation_styles_1.buttonSelected : reportNavigation_styles_1.options },
            React.createElement("div", { className: historicalNavigation_styles_1.dropdownWrapper, onClick: function () {
                    setShowDatePicker(!showDatePicker);
                } },
                React.createElement("div", { className: historicalNavigation_styles_1.wrap, id: "date-range-select", "data-showing": showDatePicker }, props && props.fromDate && props.toDate
                    ? datePickerCard_1.formatDate(props.fromDate, props.language) +
                        " - " +
                        datePickerCard_1.formatDate(props.toDate, props.language)
                    : strings.selectDateRange),
                React.createElement("div", { className: historicalNavigation_styles_1.downArrow },
                    React.createElement(arrowDown_icon_1.ArrowDownIcon, null))),
            showDatePicker ? (React.createElement("div", { className: historicalNavigation_styles_1.dateSelection },
                React.createElement(datePickerCard_1.DatePickerCard, { setDateTime: props.setDateTime, display: display, setDisplay: setDisplay, setShowDatePicker: setShowDatePicker, setArchiveMode: setArchiveMode, archiveMode: archiveMode, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, setCurrentRange: props.setRange, currentRange: props.range, forceShowCustom: props.forceShowCustom, newRangeBehaviour: false, timezone: props.timezone, toDate: props.toDate, fromDate: props.fromDate, language: props.language }))) : (undefined)),
        React.createElement("div", { className: historicalNavigation_styles_1.reportButton }, !props.loading &&
            props &&
            props.fromDate &&
            props.toDate &&
            props.agent != undefined ? (React.createElement(core_components_1.Button, { id: "report-button", onClick: getReport }, strings.runReport)) : (React.createElement(core_components_1.Button, { id: "report-button", disabled: true }, strings.runReport)))));
}
exports.HistoricalNav = HistoricalNav;
